
import { showAlert } from './alerts';

export const searchGame = async (searchValue) => {

	try {

		if (searchValue) window.location.href = `/search/${searchValue}`;

		else window.location.href = `/games-list`;

	} catch (err) {

		showAlert('error', err.response.data.message);

	}
}